/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import TabButton from 'src/shared/ui/component/button/TabButton';

import styles from './TabNav.style';

type Props = {
  items: Array,
};

const useStyles = createUseStyles(styles);

const TabNav = ({ items }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <div className={classes.root}>
      {items.map(({ key, children }) => (
        <div key={key} className={classes.item}>
          <TabButton>{children}</TabButton>
        </div>
      ))}
    </div>
  );
};

export default compose(React.memo)(TabNav);
